import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, RefObject } from 'react';
import { getInertValue } from '#cutils/react/inert-attribute';
import styles from './NavigationList.module.scss';
type Props = PropsWithChildren<{
  className?: string;
  role?: string;
  hidden?: boolean;
  inert?: boolean;
}> & {
  ref?: RefObject<HTMLUListElement | null>;
};
export function NavigationList(t0) {
  const $ = _c(14);
  let children;
  let inert;
  let ref;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      ref,
      children,
      className: t1,
      inert,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = inert;
    $[3] = ref;
    $[4] = rest;
    $[5] = t1;
  } else {
    children = $[1];
    inert = $[2];
    ref = $[3];
    rest = $[4];
    t1 = $[5];
  }
  const className = t1 === undefined ? "" : t1;
  const t2 = `${styles.navigationList} heading4 ${className}`;
  let t3;
  if ($[6] !== inert) {
    t3 = getInertValue(inert);
    $[6] = inert;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== ref || $[10] !== rest || $[11] !== t2 || $[12] !== t3) {
    t4 = <ul ref={ref} className={t2} inert={t3} {...rest}>{children}</ul>;
    $[8] = children;
    $[9] = ref;
    $[10] = rest;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}